// Dashboard.js
import React from "react";

const Dashboard = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100">
      <div className="d-flex justify-content-center mb-4">
        <img
          src="https://rean.co.in/static/media/logo.94348df8418792c29a83.png"
          alt="ChatGPT Logo"
          style={{ width: "150px", height: "200px", marginRight: "100px" }}
        />
        <img
          src="https://www.mpudc.co.in/images/MP_Logo.png"
          alt="ChatGPT Logo"
          style={{ width: "200px", height: "200px" }}
        />
      </div>
      <h1>Boda Water Treatment Plant - 1A</h1>
      <h3>Maintenance Management System</h3>
    </div>
  );
};

export default Dashboard;